import styled, { css } from 'styled-components';
import { Button } from '@sendible/design-system';
import { motion } from 'framer-motion';

export const Container = styled.div`
  ${({ theme: { colors } }) => css`
    align-items: center;
    display: flex;
    margin-left: -1rem;
    overflow-x: visible;
    padding: 0.25rem 0;
    position: relative;
    width: calc(100% + 2rem);

    .nav-button {
      position: absolute;
      background: ${colors.brandLight};
      box-shadow: 0px 1px 18px 0px ${colors.brandDarkAlpha10}, 0px 6px 10px 0px ${colors.brandDarkAlpha15},
        0px 3px 5px -1px ${colors.brandDarkAlpha20};
      z-index: 100;

      &:hover {
        background: ${colors.brandLight};
        transform: scale(1.1);
      }
    }

    .attach-prev {
      left: 1rem;
    }

    .attach-next {
      right: 1rem;
    }
  `}
`;

export const MotionButton = styled(motion(Button))``;

export const Slider = styled(motion.div)`
  ${({ theme: { colors } }) => css`
    align-items: center;
    display: flex;
    overflow-x: auto;
    scroll-behavior: smooth;
    scroll-snap-type: x mandatory;

    .skeleton {
      height: 6.5rem;
      width: 6.5rem;
    }

    & .media-slot:nth-last-child(1) {
      padding-right: 1rem;
    }

    &::-webkit-scrollbar {
      height: 1rem;
      width: 1rem;
    }

    &::-webkit-scrollbar-track {
      background: white;
    }

    &::-webkit-scrollbar-thumb {
      background-clip: padding-box;
      background-color: ${colors.brandDarkTint90};
      border-radius: 0.5rem;
      border: 0.25rem solid white;
      -webkit-border-radius: 0.5rem;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: ${colors.brandDarkTint70};
    }
  `}
`;

export const MediaSlot = styled.div`
  flex-shrink: 0;
  height: 6.5rem;
  margin: 0;
  padding: 0;
  padding-left: 1rem;
  position: relative;
  scroll-snap-align: start;
  width: 6.5rem;
`;
